import { useCallback } from "react";
import { useMutation, useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_NEWS_GET_LIST,
  MY_NEWS_SET_ITEM_READ,
  MY_NEWS_SUBSCRIPTION,
} from "my-news/graphql";

export const useMyNewsList = ({ archived }: { archived: boolean }) => {
  const { data, loading, error, fetchMore, refetch } = useQuery(
    MY_NEWS_GET_LIST,
    {
      fetchPolicy: "cache-and-network",
      variables: { page: 1, pageSize: 4, archived },
    },
  );

  useSubscription(MY_NEWS_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  const handleFetchMore = (pageSize: number) => {
    fetchMore({
      variables: {
        page: 1,
        pageSize: pageSize,
        archived,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        const prevData = prev.getMyNewsList;
        const newData = fetchMoreResult.getMyNewsList;
        const rows = newData.rows;
        const pageSize = newData.pageSize;
        const updatedData = {
          ...prevData,
          rows,
          pageSize,
        };
        const updatedResult = {
          getMyNewsList: updatedData,
        };
        return updatedResult;
      },
    });
  };

  const [setMyNewsItemReadMutation] = useMutation(MY_NEWS_SET_ITEM_READ);

  const setMyNewsItemRead = useCallback(
    async (options?: any) => {
      try {
        const result = await setMyNewsItemReadMutation(options);
        refetch();
        return result;
      } catch (error) {
        console.log({ error });
        throw error;
      }
    },
    [setMyNewsItemReadMutation, refetch],
  );

  return {
    data: data?.getMyNewsList || null,
    loading,
    error,
    handleFetchMore,
    setMyNewsItemRead,
  };
};

export default useMyNewsList;
